<template>
  <div class="shopbag">
    <div class="top"></div>
    <van-nav-bar
      title="购物袋"
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-right="editProduct"
      @click-left="back"
    >
      <template
        #right
        v-if="shopbagData.length > 0 "
      >
        <div>
          {{isEdit ? '完成' : '编辑'}}
        </div>
      </template>
    </van-nav-bar>

    <div class="scroll-box">
      <div class="main">
        <div
          class="shopbaglist"
          v-if="shopbagData.length > 0"
        >
          <div class="shopbag-bg"></div>
          <van-swipe-cell
            :disabled='!isEdit'
            v-for="(item,index) in shopbagData"
            :key="index"
          >
            <van-cell :border="false">
              <div class="clearfix cell-box">
                <div class="fl check">
                  <van-checkbox
                    v-model="item.isCheck"
                    icon-size="20px"
                    checked-color="#0C34BA"
                    @click="simpleSelect"
                  ></van-checkbox>
                </div>
                <div class="fl pro-img">
                  <img
                    class="auto-img"
                    :src="item.small_img"
                    alt=""
                  >
                </div>
                <div class="fl pro-info">
                  <div class="text-box">
                    <div class="clearfix">
                      <div class="fl text-name">{{item.name}}</div>
                      <div class="fl text-rule">{{item.rule}}</div>
                    </div>
                    <div class="text-enname">{{item.enname}}</div>
                  </div>
                  <div class="price-box">
                    <div class="fl price">￥{{item.price}}</div>
                    <div class="fr">
                      <van-stepper
                        v-model="item.count"
                        theme="round"
                        button-size="24"
                        disable-input
                        @change="modifyCount(item)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </van-cell>
            <template #right>
              <van-button
                square
                type="danger"
                text="删除"
                @click="removeOneShopbag(item.sid,index)"
              />
            </template>
          </van-swipe-cell>

          <div>
            <van-submit-bar
              v-show="!isEdit"
              :price="total"
              button-text="提交订单"
              button-color="#0C34BA"
              @submit="commit"
            >
              <van-checkbox
                v-model="allCheck"
                checked-color="#0C34BA"
                @click="allSelect"
              >全选</van-checkbox>
            </van-submit-bar>

            <van-submit-bar
              v-show="isEdit"
              button-text="删除选择"
              button-color="#ee0a24"
              @submit="removeMoreShopbag"
            >
              <van-checkbox
                v-model="allCheck"
                checked-color="#0C34BA"
                @click="allSelect"
              >全选</van-checkbox>
            </van-submit-bar>
          </div>
        </div>
        <div
          v-else
          class="empty-box"
        >
          <van-empty
            description="购物车空空如也,去逛一逛！"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
          >
            <van-button
              round
              type="info"
              class="bottom-button"
              @click="goMenu"
            >
              逛一逛
            </van-button>
          </van-empty>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import "../../assets/less/shopbag.less";
import { utils } from "../../assets/js/Utils";
export default {
  inject: ["reload"],

  data() {
    return {
      isEdit: false,
      allCheck: false,
      shopbagData: [],
      total: 0, // 单位是分
    };
  },
  created() {
    // 查询购物袋
    this.findShopbag();
  },
  methods: {
    // 返回
    back() {
      this.$router.go(-1);
    },

    // 编辑商品
    editProduct() {
      this.isEdit = !this.isEdit;
    },

    // 查询购物袋
    findShopbag() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "GET",
        url: "/findAllShopcart",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 5000) {
            result.data.result.map((v) => {
              v.isCheck = false;
            });
            this.shopbagData = result.data.result;
          } else {
            this.$toast(result.data.msg);
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 全选
    allSelect() {
      this.shopbagData.map((v) => {
        v.isCheck = this.allCheck;
      });

      // 计算总价
      this.sum();
    },

    // 单选
    simpleSelect() {
      // 计算总价
      this.sum();

      for (let i = 0; i < this.shopbagData.length; i++) {
        if (!this.shopbagData[i].isCheck) {
          this.allCheck = false;
          return;
        }
      }
      this.allCheck = true;
    },

    // 修改商品数量
    modifyCount(item) {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      // 参数序列化
      let data = utils.queryString({
        appkey: this.appkey,
        tokenString,
        sid: item.sid,
        count: item.count,
      });

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "POST",
        url: "/modifyShopcartCount",
        data,
      })
        .then((result) => {
          this.$toast.clear();

          // 计算总价
          this.sum();
          if (result.data.code !== 6000) {
            this.$toast(result.data.msg);
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 删除购物袋数据
    removeShopbag(sids) {
      // sids: sid的集合，类型array

      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      // 参数序列化
      let data = utils.queryString({
        appkey: this.appkey,
        tokenString,
        sids: JSON.stringify(sids),
      });

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      return this.axios({
        method: "POST",
        url: "/deleteShopcart",
        data,
      });
    },

    // 删除单个商品
    removeOneShopbag(sid, index) {
      this.removeShopbag([sid])
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 7000) {
            this.shopbagData.splice(index, 1);
            this.reload();
          }
          this.$toast(result.data.msg);
          // 计算总价
          this.sum();
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 删除多个商品
    removeMoreShopbag() {
      // 查找选择的商品
      let sids = [];

      this.shopbagData.map((v) => {
        if (v.isCheck) {
          sids.push(v.sid);
        }
      });
      this.removeShopbag(sids)
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 7000) {
            for (let i = 0; i < this.shopbagData.length; i++) {
              if (this.shopbagData[i].isCheck) {
                this.shopbagData.splice(i, 1);
                i--;
              }
              // 计算总价
              this.sum();
            }
            this.reload();
          }
          this.$toast(result.data.msg);
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 计算被勾选的总价
    sum() {
      this.total = 0;
      this.shopbagData.map((v) => {
        if (v.isCheck) {
          // 获取到的price是字符串
          // this.total += v.count * Number(v.price)   // 显式转换
          this.total += v.count * v.price; // 隐式转换
        }
      });
      this.total *= 100;
    },

    // 回到菜单
    goMenu() {
      this.$router.push({ name: "Menu" });
    },

    // 提交订单
    commit() {
      // 查找需要购买的商品, sid
      let sids = [];
      this.shopbagData.map((v) => {
        if (v.isCheck) {
          sids.push(v.sid);
        }
      });
      if (sids.length === 0) {
        this.$toast("请选择购买商品");
        return;
      }

      // 以某个字符将数组合并分割成字符串
      sids = sids.join("-");
      this.$router.push({ name: "Pay", query: { sids } });
    },
  },
};
</script>